// Whether this device shows the server banner over the Classic channel list. On unless turned off in Settings →
// Appearance → Server banner. Remembered on this device only, like the layout (layout.ts). Storage can be missing or
// throw (private windows): then the choice lasts until reload.
import { useSyncExternalStore } from "react";

export const BANNER_KEY = "bloom:serverBanner";

/** A stored value as on or off; anything but "off" is on. */
export const parseBannerPref = (raw: unknown): boolean => raw !== "off";

function stored(): boolean {
  try {
    return parseBannerPref(localStorage.getItem(BANNER_KEY));
  } catch {
    return true;
  }
}

const listeners = new Set<() => void>();
let current = stored();

export function setServerBanner(on: boolean) {
  current = on;
  try {
    localStorage.setItem(BANNER_KEY, on ? "on" : "off");
  } catch {
    // private mode: still applies for this page
  }
  for (const fn of listeners) fn();
}

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  // Another tab changed it.
  const onStorage = (e: StorageEvent) => {
    if (e.key !== BANNER_KEY) return;
    current = stored();
    fn();
  };
  addEventListener("storage", onStorage);
  return () => {
    listeners.delete(fn);
    removeEventListener("storage", onStorage);
  };
};

export const useServerBanner = (): boolean => useSyncExternalStore(subscribe, () => current);
